// Custom ECharts build with only required components
import * as echarts from 'echarts/core'
import {
  PieChart,
  BarChart,
  LineChart,
  TreemapChart
} from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  MarkLineComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'

// Register only the components we need
echarts.use([
  PieChart,
  BarChart,
  LineChart,
  TreemapChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  MarkLineComponent,
  CanvasRenderer
])

export default echarts